// extracted by mini-css-extract-plugin
export var legendIndicator = "_dm-1";
export var legendRight = "_dm-0";